import { render, staticRenderFns } from "./compModal.vue?vue&type=template&id=0ce05f53&scoped=true"
import script from "./compModal.vue?vue&type=script&lang=js"
export * from "./compModal.vue?vue&type=script&lang=js"
import style0 from "./compModal.vue?vue&type=style&index=0&id=0ce05f53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce05f53",
  null
  
)

export default component.exports